"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toExpansion = void 0;
function toExpansion(ps) {
    return ps.map(p => p.map(c => [c]));
}
exports.toExpansion = toExpansion;
//# sourceMappingURL=to-expansion.js.map